import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { getCdnImage } from 'functions';

const styles = require('./logo.css');

interface IProps {
  image: string;
}

export default class Logo extends BaseComponent<any, IProps> {
  render() {
    const customStyle = {
      logo: {
        backgroundImage: `url(${getCdnImage(this.props.image)})`
      }
    };

    return (
      <div className={`chk-logo__content ${styles.component}`} style={customStyle.logo} id='logo-content' />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Widget/Header/Logo/index.tsx